import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./styles.module.scss";

const sections = [["politica-de-privacidade", "1. Política de privacidade"], ["objeto", "2. Objeto"], ["condicoes-gerais", "3. Condições gerais"], ["cadastro", "4. Cadastro e acesso à conta"], ["anuncios-vedados", "5. Anúncios vedados"], ["restricoes-de-uso", "6. Restrições de uso"], ["profissionais", "7. Regras para profissionais"], ["clientes", "8. Regras para clientes"], ["aceitacao-do-termo", "9. Aceitação e alterações do termo"], ["suspensao-do-programa", "10. Suspensão e cessação do programa"], ["leis-e-foro", "11. Leis e foro"], ["declaracao-do-profissional", "12. Declaração do profissional"]];

export default function PrivacyPolicies() {
    const { hash } = useLocation();

    useEffect(() => {
        const scrollToSection = (sectionHash) => {
            const section = document.getElementById(sectionHash.slice(1));
            if (section) {
                section.scrollIntoView();
            }
        };

        const handleHashChange = () => scrollToSection(window.location.hash);

        scrollToSection(hash);
        window.addEventListener("hashchange", handleHashChange);
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, [hash]);

    return (<main className={styles.page} id="topo">
            <article className={styles.document} aria-labelledby="document-title">
                <header className={styles.header}>
                    <p className={styles.eyebrow}>CONTRATE.BA · SETRE</p>
                    <h1 id="document-title">Política de privacidade e termos de uso</h1>
                    <p>
                        Documento unificado para clientes e profissionais que utilizam o portal e o
                        aplicativo CONTRATE.BA.
                    </p>
                    <p>
                        O CONTRATE.BA integra o Serviço de Intermediação para o Trabalho Autônomo do
                        Governo do Estado da Bahia, sob a responsabilidade da Secretaria do Trabalho,
                        Emprego, Renda e Esporte (SETRE), e oferece uma plataforma virtual para
                        intermediação de serviços e geração de trabalho e renda para profissionais
                        autônomos.
                    </p>
                </header>

                <nav className={styles.summary} aria-labelledby="summary-title">
                    <h2 id="summary-title">Neste documento</h2>
                    <ul>
                        {sections.map(([id, title]) => (<li key={id}>
                                <a href={`#${id}`}>{title}</a>
                            </li>))}
                    </ul>
                </nav>

                <section id="politica-de-privacidade" className={styles.section}>
                    <h2>1. Política de privacidade</h2>
                    <p>
                        A política de privacidade aplica-se a clientes e profissionais. A aceitação do
                        Termo de Responsabilidade e Condições Gerais de Uso do CONTRATE.BA implica a
                        manifestação de consentimento para o tratamento de dados pessoais pelo Estado
                        da Bahia, gerenciador do serviço, na forma do art. 8º, § 1º, da Lei Federal
                        nº 13.709, de 14 de agosto de 2018 (Lei Geral de Proteção de Dados Pessoais —
                        LGPD), observadas as premissas a seguir.
                    </p>

                    <h3 id="controlador-e-operadores">1.1. Controlador e operadores dos dados</h3>
                    <p>
                        O Estado da Bahia, gerenciador do CONTRATE.BA, é o controlador dos dados
                        pessoais. Para o gerenciamento dos serviços, poderá realizar o tratamento,
                        incluindo coleta e compartilhamento, por meio de pessoas jurídicas de direito
                        público ou privado contratadas ou conveniadas para a gestão do CONTRATE.BA,
                        que assumem as responsabilidades de operadoras de dados pessoais.
                    </p>
                    <p>
                        O consentimento refere-se ao tratamento de dados de pessoas naturais
                        determinadas. Conforme os termos de origem, dados de pessoas jurídicas podem
                        ser compartilhados independentemente de manifestação de anuência.
                    </p>

                    <h3 id="dados-coletados">1.2. Dados fornecidos e coletados</h3>
                    <p>
                        Para os efeitos do consentimento, consideram-se dados pessoais informações
                        como documento de identificação pessoal, CPF, RG, título de eleitor e cadastro
                        PIS, sem prejuízo de outros dados necessários à efetivação da contratação de
                        serviços autônomos.
                    </p>
                    <ul>
                        <li>
                            <strong>Clientes:</strong> dados pessoais e de contato fornecidos no
                            cadastro.
                        </li>
                        <li>
                            <strong>Profissionais:</strong> dados cadastrais, documentação exigida,
                            principais habilidades, categorias de interesse para atuação e demais
                            informações solicitadas. O uso da imagem está previsto na declaração
                            específica do profissional, ao final deste documento.
                        </li>
                    </ul>

                    <h3 id="finalidades-dos-dados">1.3. Finalidades do tratamento</h3>
                    <p>
                        Os dados pessoais, desde a coleta, somente poderão ser utilizados no âmbito
                        do CONTRATE.BA. É vedada a utilização para finalidade diversa, ressalvada
                        manifestação expressa de consentimento nesse sentido.
                    </p>
                    <p>
                        As informações são utilizadas para cadastro, acesso à conta, gerenciamento
                        dos serviços e intermediação entre clientes e profissionais. A SETRE poderá
                        utilizar as informações disponibilizadas pelos usuários no acesso ao
                        CONTRATE.BA para estudos, finalidades estatísticas e aprimoramento do
                        programa.
                    </p>

                    <h3 id="compartilhamento-de-dados">1.4. Compartilhamento e informações visíveis</h3>
                    <p>
                        As informações de contato fornecidas serão disponibilizadas às partes
                        envolvidas — cliente e profissional — para contato direto e contratação do
                        serviço. As avaliações recíprocas e seus resultados ficarão visíveis a todos
                        os usuários, com caráter meramente indicativo.
                    </p>
                    <p>
                        O profissional não deve informar o telefone ou o endereço do cliente a
                        terceiros. Essa conduta está sujeita à advertência prevista nas regras de
                        uso aplicáveis aos profissionais.
                    </p>

                    <h3 id="revogacao-do-consentimento">1.5. Revogação do consentimento</h3>
                    <p>
                        O consentimento pode ser revogado a qualquer momento, conforme o art. 8º,
                        § 5º, da Lei nº 13.709/2018. Nos termos dos documentos de origem, a
                        permanência no CONTRATE.BA pressupõe o tratamento de dados pessoais; por
                        isso, a revogação do consentimento implicará a exclusão do cadastro, sem
                        prejuízo dos tratamentos realizados antes da revogação.
                    </p>
                </section>

                <section id="objeto" className={styles.section}>
                    <h2>2. Objeto</h2>
                    <p>
                        Este Termo de Uso e Responsabilidade estabelece e disciplina as condições de
                        utilização da plataforma CONTRATE.BA. Clientes e profissionais comprometem-se
                        a respeitar e cumprir as regras aqui estabelecidas.
                    </p>
                </section>

                <section id="condicoes-gerais" className={styles.section}>
                    <h2>3. Condições gerais</h2>
                    <p>
                        O CONTRATE.BA é uma plataforma virtual disponibilizada pela SETRE para
                        intermediação de serviços entre clientes e profissionais autônomos, incluindo
                        microempreendedores individuais (MEI), inseridos no programa.
                    </p>
                    <ul>
                        <li>
                            A adesão é livre e o acesso é gratuito. O pagamento é devido
                            exclusivamente pelo serviço realizado e é efetuado diretamente pelo
                            cliente ao profissional contratado.
                        </li>
                        <li>
                            O Estado da Bahia não recebe valores pelo uso da plataforma. É vedada
                            qualquer cobrança por seus órgãos, servidores ou terceiros pela
                            utilização do CONTRATE.BA.
                        </li>
                        <li>
                            A escolha do profissional é livre ao cliente, sem interferência da SETRE
                            ou de outro órgão do Estado.
                        </li>
                        <li>
                            Valores e condições de realização dos serviços são de livre e exclusiva
                            negociação entre cliente e profissional, observadas estas regras.
                        </li>
                        <li>
                            Clientes e profissionais são avaliados reciprocamente, e os resultados
                            ficam visíveis a todos os usuários, com caráter meramente indicativo.
                        </li>
                        <li>É expressamente vedado o trabalho de menores, mesmo acompanhados dos pais.</li>
                        <li>
                            A presença de acompanhantes, ajudantes, auxiliares ou outros
                            profissionais, ainda que cadastrados, depende de autorização do cliente.
                        </li>
                        <li>
                            Confirmações e cancelamentos de serviços agendados são comunicados por
                            e-mail e notificação no aplicativo. Cabe a ambas as partes verificar as
                            mensagens recebidas.
                        </li>
                    </ul>
                    <p>
                        O CONTRATE.BA se exime de responsabilidade pela qualidade dos serviços,
                        ausências ou atrasos do profissional e por perdas, danos e prejuízos de
                        qualquer natureza decorrentes da relação entre cliente e profissional.
                    </p>
                    <p>
                        A plataforma disponibiliza links, banners, botões e ferramentas de busca que
                        permitem acessar páginas de terceiros para facilitar a busca de informações.
                    </p>
                    <p>
                        A inscrição, a capacitação e a disponibilização do nome do profissional na
                        plataforma não configuram vínculo empregatício ou de prestação de serviço
                        autônomo com a Administração Direta ou Indireta do Estado da Bahia ou com
                        entidades responsáveis pela capacitação. Também não geram responsabilidade
                        solidária ou subsidiária do Estado com órgãos ou instituições públicas ou
                        privadas parceiras do programa.
                    </p>
                </section>

                <section id="cadastro" className={styles.section}>
                    <h2>4. Cadastro e acesso à conta</h2>
                    <h3 id="cadastro-do-profissional">4.1. Cadastro do profissional</h3>
                    <p>
                        O cadastro é realizado pelo aplicativo e validado virtualmente. Devem ser
                        informadas as principais habilidades, as categorias de interesse e as demais
                        informações solicitadas. A confirmação do pré-cadastro ocorre pelo aplicativo.
                    </p>
                    <p>
                        O profissional deve preencher todos os campos obrigatórios, anexar a
                        documentação necessária e assinar este termo e a declaração específica de
                        autorização do uso de imagem no aplicativo e nas demais ferramentas do
                        programa. As informações devem ser exatas, precisas, verdadeiras e mantidas
                        atualizadas.
                    </p>
                    <h3 id="cadastro-do-cliente">4.2. Cadastro do cliente</h3>
                    <p>
                        O cadastro é realizado pelo aplicativo mediante o fornecimento de dados
                        pessoais e de contato. Após o preenchimento correto com dados verídicos,
                        a confirmação ocorre por e-mail e/ou notificação no aplicativo.
                    </p>
                    <h3 id="suspensao-do-cadastro">4.3. Suspensão ou cancelamento do cadastro</h3>
                    <p>
                        O cadastro ou pré-cadastro de qualquer usuário poderá ser suspenso temporária
                        ou definitivamente se constatado o fornecimento de informações inverídicas,
                        sem direito a indenização ou ressarcimento pela suspensão.
                    </p>
                    <h3 id="acesso-a-conta">4.4. Acesso e responsabilidade pela conta</h3>
                    <p>
                        O acesso à conta é realizado com CPF ou CNPJ e a senha cadastrada na
                        inscrição. O usuário é responsável pelas informações de acesso e deve
                        informar imediatamente qualquer utilização não autorizada.
                    </p>
                    <p>
                        É permitido um único cadastro por usuário, sendo vedada a cessão ou
                        transferência da conta a terceiros, a qualquer título.
                    </p>
                </section>

                <section id="anuncios-vedados" className={styles.section}>
                    <h2>5. Anúncios vedados</h2>
                    <p>
                        A plataforma destina-se exclusivamente à intermediação de serviços de
                        trabalhadores autônomos que integram o programa de apoio ao trabalhador
                        autônomo da SETRE. Não são admitidos outros anúncios, como venda ou troca de
                        bens móveis e imóveis.
                    </p>
                    <p>
                        Anúncios ilegais ou ofensivos a terceiros são proibidos, sob pena de exclusão
                        do cadastro do usuário.
                    </p>
                </section>

                <section id="restricoes-de-uso" className={styles.section}>
                    <h2>6. Restrições de uso</h2>
                    <p>
                        Clientes e profissionais poderão ser advertidos ou ter o cadastro suspenso
                        temporária ou definitivamente em decorrência das condutas descritas a seguir,
                        a partir das informações disponibilizadas pelos usuários em suas avaliações.
                    </p>
                </section>

                <section id="profissionais" className={styles.section}>
                    <h2>7. Regras para profissionais</h2>
                    <h3 id="advertencia-do-profissional">7.1. Advertência</h3>
                    <p>A advertência será registrada no cadastro do profissional pela prática de:</p>
                    <ul>
                        <li>Apresentar-se ao local do serviço sem carteira de identidade.</li>
                        <li>
                            Deixar de comparecer sem informar o cliente com antecedência suficiente
                            para possibilitar novo agendamento.
                        </li>
                        <li>
                            Solicitar aumento da diária, gorjetas, transporte, alimentação ou
                            vantagens não estipuladas na aceitação do serviço.
                        </li>
                        <li>Informar o telefone ou o endereço do cliente a terceiros.</li>
                        <li>Fumar no local de serviço.</li>
                        <li>
                            Deixar de utilizar roupas adequadas e equipamentos de proteção individual
                            (EPIs) necessários ao serviço.
                        </li>
                    </ul>
                    <h3 id="suspensao-do-profissional">7.2. Suspensão temporária</h3>
                    <p>A suspensão temporária será de 15 dias nas seguintes situações:</p>
                    <ul>
                        <li>Agir com imprudência, imperícia ou negligência na execução do serviço.</li>
                        <li>Submeter a si ou a terceiros a situação de risco.</li>
                        <li>Ser advertido mais de uma vez, sucessiva ou alternadamente.</li>
                    </ul>
                    <h3 id="exclusao-do-profissional">7.3. Exclusão do cadastro</h3>
                    <ul>
                        <li>Fazer-se substituir por outro profissional, mesmo com anuência do cliente.</li>
                        <li>
                            Fazer uso de drogas ou bebida alcoólica no local de serviço ou
                            apresentar-se com sinais de embriaguez.
                        </li>
                        <li>
                            Comparecer acompanhado sem autorização prévia do cliente, mesmo que o
                            acompanhante seja ajudante, auxiliar ou profissional cadastrado.
                        </li>
                        <li>Praticar quaisquer hipóteses de infração penal.</li>
                        <li>Apresentar declaração ou documento falso para cadastro ou alteração cadastral.</li>
                        <li>Abandonar o programa sem prévio aviso.</li>
                        <li>Ter o cadastro suspenso por três vezes sucessivas ou cinco intercaladas.</li>
                        <li>
                            Discutir, desacatar, afrontar, desrespeitar ou agir grosseiramente com
                            clientes, colegas ou funcionários do programa.
                        </li>
                        <li>Deixar de indenizar ou corrigir dano comprovadamente provocado ao cliente.</li>
                        <li>Utilizar expressões ou adotar comportamento preconceituoso, racista ou violento.</li>
                    </ul>
                </section>

                <section id="clientes" className={styles.section}>
                    <h2>8. Regras para clientes</h2>
                    <h3 id="suspensao-do-cliente">8.1. Suspensão temporária</h3>
                    <p>A suspensão temporária será de 15 dias nas seguintes situações:</p>
                    <ul>
                        <li>
                            Desistir do serviço ou impossibilitar sua realização pelo profissional
                            sem comunicação prévia.
                        </li>
                        <li>Realizar pagamento em desconformidade com o acordado com o profissional.</li>
                    </ul>
                    <h3 id="exclusao-do-cliente">8.2. Exclusão do cadastro</h3>
                    <ul>
                        <li>Não realizar o pagamento acordado com o profissional.</li>
                        <li>Utilizar expressões ou adotar comportamento preconceituoso, racista ou violento.</li>
                        <li>Ter o cadastro suspenso por três vezes sucessivas ou cinco intercaladas.</li>
                        <li>
                            Discutir, desacatar, afrontar, desrespeitar ou agir grosseiramente com o
                            profissional ou funcionários do programa.
                        </li>
                    </ul>
                </section>

                <section id="aceitacao-do-termo" className={styles.section}>
                    <h2>9. Aceitação e alterações do termo</h2>
                    <p>
                        A leitura deste termo é obrigatória para os usuários. A utilização ou o
                        acesso ao portal e/ou aplicativo exige a aceitação sem reservas das condições
                        estabelecidas. Avisos e instruções publicados pelo CONTRATE.BA integram o
                        termo e devem ser observados integralmente.
                    </p>
                    <p>
                        O CONTRATE.BA reserva-se o direito de modificar, suprimir ou ampliar o termo,
                        livremente e a qualquer tempo, sem comunicação prévia, para aprimoramento e
                        melhoria do portal. A nulidade ou invalidade de uma cláusula não prejudica
                        a validade e a eficácia das demais ou do próprio termo.
                    </p>
                    <p>
                        Se constatada a não adaptação do profissional às atividades práticas e de
                        capacitação ocupacional, caberá à supervisão determinar seu remanejamento
                        para outras atividades ou desligamento.
                    </p>
                    <p>
                        O usuário compromete-se a utilizar a ferramenta somente para os fins
                        permitidos, conforme este termo, os termos específicos dos processos de
                        intermediação e o manual do CONTRATE.BA. É vedado reproduzir, duplicar,
                        copiar, vender, comercializar ou revender as informações do CONTRATE.BA a
                        qualquer título.
                    </p>
                </section>

                <section id="suspensao-do-programa" className={styles.section}>
                    <h2>10. Suspensão e cessação do programa</h2>
                    <p>
                        Sem prejuízo das restrições de uso, a SETRE reserva-se o direito de recusar
                        ou retirar o acesso ao portal a qualquer momento, sem comunicação prévia.
                    </p>
                    <p>
                        Por questões técnicas, operacionais ou financeiras, o CONTRATE.BA poderá ser
                        temporariamente suspenso ou definitivamente extinto. Nessas hipóteses, os
                        usuários serão previamente informados.
                    </p>
                </section>

                <section id="leis-e-foro" className={styles.section}>
                    <h2>11. Leis e foro</h2>
                    <p>
                        Este termo está de acordo com as leis vigentes no Brasil. Fica eleito o foro
                        da cidade de Salvador/BA para toda disputa sobre este termo ou a ele
                        relacionada.
                    </p>
                </section>

                <section id="declaracao-do-profissional" className={styles.section}>
                    <h2>12. Declaração do profissional</h2>
                    <blockquote>
                        Autorizo o uso da minha imagem para fins de divulgação na plataforma
                        CONTRATE.BA junto ao cliente e declaro estar ciente de que, na hipótese de
                        suspensão do cadastro, serei convocado pela SETRE para reorientação e, na
                        hipótese de exclusão do cadastro, serei imediatamente desligado do CONTRATE.BA.
                    </blockquote>
                </section>

                <footer className={styles.footer}>
                    <a href="#topo">Voltar ao topo</a>
                </footer>
            </article>
        </main>);
}